// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { PROFILE, UPLOAD_PROFILE_IMAGE, PROFILE_EDIT, KYC_DOCUMENTS, UPLOAD_KYC_DOCUMENTS, KYC_DOCUMENTS_DELETE, ALL_CONTACT_PERSON, CLIENT_LIST, POLICY_COMPANY_LIST, CLIENT_DETAILS, KYC_DOCUMENTS_DOWNLOAD, CHANGE_PASSWORD } from '../../../../../common/constant'
import { get, post } from '../../../../../common/api'
import Api from '../../../../../common/api/multipart'

export const actionProfile = createAsyncThunk('MyProfileStore/actionProfile', async (params, thunkAPI) => {
    return await get(PROFILE, params, thunkAPI)
})

export const actionUploadProfileImage = createAsyncThunk('MyProfileStore/actionUploadProfileImage', async (params) => {
    return await Api.multipart(UPLOAD_PROFILE_IMAGE, params)

})

export const actionProfileEdit = createAsyncThunk('MyProfileStore/actionProfileEdit', async (params, thunkAPI) => {
    return await post(PROFILE_EDIT, params, thunkAPI)
})

export const actionKYCDocuments = createAsyncThunk('MyProfileStore/actionKYCDocuments', async (params, thunkAPI) => {
    return await get(KYC_DOCUMENTS, params, thunkAPI)
})

export const actionUploadKYCDocuments = createAsyncThunk('MyProfileStore/actionUploadKYCDocuments', async (params, thunkAPI) => {
    return await Api.multipart(UPLOAD_KYC_DOCUMENTS, params, thunkAPI)
})

export const actionKYCDocumentsDelete = createAsyncThunk('MyProfileStore/actionKYCDocumentsDelete', async (params, thunkAPI) => {
    return await get(KYC_DOCUMENTS_DELETE, params, thunkAPI)
})

export const actionKYCDocumentsDownload = createAsyncThunk('MyProfileStore/actionKYCDocumentsDownload', async (params, thunkAPI) => {
    return await get(KYC_DOCUMENTS_DOWNLOAD, params, thunkAPI)
})


export const actionAllContactPerson = createAsyncThunk('MyProfileStore/actionAllContactPerson', async (params, thunkAPI) => {
    return await get(ALL_CONTACT_PERSON, params, thunkAPI)
})

export const actionClientList = createAsyncThunk('MyProfileStore/actionClientList', async (params, thunkAPI) => {
    return await get(CLIENT_LIST, params, thunkAPI)
})

export const actionPolicyCompanyList = createAsyncThunk('MyProfileStore/actionPolicyCompanyList', async (params, thunkAPI) => {
    return await post(POLICY_COMPANY_LIST, params, thunkAPI)
})

export const actionClientDetails = createAsyncThunk('MyProfileStore/actionClientDetails', async (params, thunkAPI) => {
    return await get(CLIENT_DETAILS, params, thunkAPI)
})

export const actionChangePassword = createAsyncThunk('MyProfileStore/actionChangePassword', async (params, thunkAPI) => {
    return await post(CHANGE_PASSWORD, params, thunkAPI)
})

export const myProfileSlice = createSlice({
    name: 'MyProfileStore',

    initialState: {
        //profile
        loadingProfile: false,
        profile: null,

        //uploadProfileImage
        loadingUploadProfileImage: false,
        uploadProfileImage: null,

        //profileEdit
        loadingProfileEdit: false,
        profileEdit: null,

        //KYC Documents
        loadingKYCDocuments: false,
        KYCDocuments: false,

        //upload KYC Documents
        loadingUploadKYCDocuments: false,
        uploadKYCDocuments: false,

        //KYC Documents Delete
        loadingKYCDocumentsDelete: false,
        KYCDocumentsDelete: false,

        //KYC Documents Download
        loadingKYCDocumentsDownload: false,
        KYCDocumentsDownload: false,

        //contact person
        loadingContactPerson: false,
        contactPerson: false,

        //client list
        loadingClientList: false,
        clientList: false,

        //client list
        loadingPolicyCompanyList: false,
        policyCompanyList: false,

        //client details
        loadingClientDetails: false,
        clientDetails: false,

        //Change PAssword
        loadingChangePassword: false,
        changePassword: null,
    },
    reducers: {
        //reset or delete public store data
        resetProfileResponse: (state) => {
            state.profile = null
        },

        resetUploadProfileImageResponse: (state) => {
            state.uploadProfileImage = null
        },

        resetProfileEditResponse: (state) => {
            state.profileEdit = null
        },
        resetKYCDocumentsResponse: (state) => {
            state.KYCDocuments = null
        },
        resetUploadKYCDocumentsResponse: (state) => {
            state.uploadKYCDocuments = null
        },
        resetKYCDocumentsDeleteResponse: (state) => {
            state.KYCDocumentsDelete = null
        },
        resetKYCDocumentsDownloadeResponse: (state) => {
            state.KYCDocumentsDownload = null
        },
        resetContactPersonResponse: (state) => {
            state.contactPerson = null
        },
        resetClientListResponse: (state) => {
            state.clientList = null
        },
        resetPolicyCompanyList: (state) => {
            state.policyCompanyList = null
        },
        resetClientDetailsResponse: (state) => {
            state.clientDetails = null
        },
        resetChangePasswordResponse: (state) => {
            state.changePassword = null
        }
    },
    extraReducers: builder => {
        builder
            //profile
            .addCase(actionProfile.pending, (state) => {
                state.loadingProfile = true
            })
            .addCase(actionProfile.fulfilled, (state, action) => {
                state.loadingProfile = false
                state.profile = action.payload
            })
            .addCase(actionProfile.rejected, (state) => {
                state.loadingProfile = false
            })

            //uploadProfileImage
            .addCase(actionUploadProfileImage.pending, (state) => {
                state.loadingUploadProfileImage = true
            })
            .addCase(actionUploadProfileImage.fulfilled, (state, action) => {
                state.loadingUploadProfileImage = false
                state.uploadProfileImage = action.payload
            })
            .addCase(actionUploadProfileImage.rejected, (state) => {
                state.loadingUploadProfileImage = false
            })

            //profileEdit
            .addCase(actionProfileEdit.pending, (state) => {
                state.loadingProfileEdit = true
            })
            .addCase(actionProfileEdit.fulfilled, (state, action) => {
                state.loadingProfileEdit = false
                state.profileEdit = action.payload
            })
            .addCase(actionProfileEdit.rejected, (state) => {
                state.loadingProfileEdit = false
            })

            //kyc documents
            .addCase(actionKYCDocuments.pending, (state) => {
                state.loadingKYCDocuments = true
            })
            .addCase(actionKYCDocuments.fulfilled, (state, action) => {
                state.loadingKYCDocuments = false
                state.KYCDocuments = action.payload
            })
            .addCase(actionKYCDocuments.rejected, (state) => {
                state.loadingKYCDocuments = false
            })

            //upload kyc documents
            .addCase(actionUploadKYCDocuments.pending, (state) => {
                state.loadingUploadKYCDocuments = true
            })
            .addCase(actionUploadKYCDocuments.fulfilled, (state, action) => {
                state.loadingUploadKYCDocuments = false
                state.uploadKYCDocuments = action.payload
            })
            .addCase(actionUploadKYCDocuments.rejected, (state) => {
                state.loadingUploadKYCDocuments = false
            })

            //kyc documents delete
            .addCase(actionKYCDocumentsDelete.pending, (state) => {
                state.loadingKYCDocumentsDelete = true
            })
            .addCase(actionKYCDocumentsDelete.fulfilled, (state, action) => {
                state.loadingKYCDocumentsDelete = false
                state.KYCDocumentsDelete = action.payload
            })
            .addCase(actionKYCDocumentsDelete.rejected, (state) => {
                state.loadingKYCDocumentsDelete = false
            })

            //kyc documents download
            .addCase(actionKYCDocumentsDownload.pending, (state) => {
                state.loadingKYCDocumentsDownload = true
            })
            .addCase(actionKYCDocumentsDownload.fulfilled, (state, action) => {
                state.loadingKYCDocumentsDownload = false
                state.KYCDocumentsDownload = action.payload
            })
            .addCase(actionKYCDocumentsDownload.rejected, (state) => {
                state.loadingKYCDocumentsDownload = false
            })

            //contact person
            .addCase(actionAllContactPerson.pending, (state) => {
                state.loadingContactPerson = false
            })
            .addCase(actionAllContactPerson.fulfilled, (state, action) => {
                state.loadingContactPerson = true
                state.contactPerson = action.payload
            })
            .addCase(actionAllContactPerson.rejected, (state) => {
                state.loadingContactPerson = false
            })

            //client list
            .addCase(actionClientList.pending, (state) => {
                state.loadingClientList = true
            })
            .addCase(actionClientList.fulfilled, (state, action) => {
                state.loadingClientList = false
                state.clientList = action.payload
            })
            .addCase(actionClientList.rejected, (state) => {
                state.loadingClientList = false
            })

            // Policy Client List
            .addCase(actionPolicyCompanyList.pending, (state) => {
                state.loadingPolicyCompanyList = true
            })
            .addCase(actionPolicyCompanyList.fulfilled, (state, action) => {
                state.loadingPolicyCompanyList = false
                state.policyCompanyList = action.payload
            })
            .addCase(actionPolicyCompanyList.rejected, (state) => {
                state.loadingPolicyCompanyList = false
            })

            //client details
            .addCase(actionClientDetails.pending, (state) => {
                state.loadingClientDetails = true
            })
            .addCase(actionClientDetails.fulfilled, (state, action) => {
                state.loadingClientDetails = false
                state.clientDetails = action.payload
            })
            .addCase(actionClientDetails.rejected, (state) => {
                state.loadingClientDetails = false
            })

            //change Password
            .addCase(actionChangePassword.pending, (state) => {
                state.loadingChangePassword = true
            })
            .addCase(actionChangePassword.fulfilled, (state, action) => {
                state.loadingChangePassword = true
                state.changePassword = action.payload
            })
            .addCase(actionChangePassword.rejected, (state) => {
                state.loadingChangePassword = false
            })
    }
})
export const { resetProfileResponse, resetUploadProfileImageResponse, resetProfileEditResponse, resetKYCDocumentsResponse, resetUploadKYCDocumentsResponse, resetKYCDocumentsDeleteResponse, resetContactPersonResponse, resetClientListResponse, resetPolicyCompanyList, resetClientDetailsResponse, resetKYCDocumentsDownloadeResponse, resetChangePasswordResponse } = myProfileSlice.actions

export default myProfileSlice.reducer